import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  listSupBalance ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupBalance(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/posc/listSupBalance', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/posc/listSupBalance', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  queryMarketingfeeDetail ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryMarketingfeeDetail(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierMarketingfee/queryMarketingfeeDetail', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierMarketingfee/queryMarketingfeeDetail', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  queryActivity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryActivity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierMarketingfee/queryActivity', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierMarketingfee/queryActivity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  queryOrderList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryOrderList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierMarketingfee/queryOrderList', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierMarketingfee/queryOrderList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  queryStatistics ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryStatistics(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supplierMarketingfee/statistics', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supplierMarketingfee/statistics', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/finance.js